export enum FEATURE_FLAGS {
  SOME_TEST_FLAG = 'some-test-flag',
  RFIS_FE_DUE_DATE_TO_APPLY_PROJECT_TZ_FROM = 'rfis-fe-due-date-to-apply-project-tz-from',
  MAINTENANCE_MODE = 'ab-rfis-maintenance-mode',
}

export const DEFAULT_FEATURE_FLAGS_VALUES: { [key in FEATURE_FLAGS]: boolean | number } = {
  [FEATURE_FLAGS.SOME_TEST_FLAG]: 100,
  [FEATURE_FLAGS.RFIS_FE_DUE_DATE_TO_APPLY_PROJECT_TZ_FROM]: 4095742606000, // timestamp of Thursday, October 15, 2099 1:16:46 PM GMT+03:00
  [FEATURE_FLAGS.MAINTENANCE_MODE]: false,
};
